import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Client Pages
import PublicStart from './pages/PublicStart';
import ClientAccess from './pages/ClientAccess';
import AssessmentWelcome from './pages/client/AssessmentWelcome';
import ClientInfo from './pages/client/ClientInfo';
import Consent from './pages/client/Consent';
import InvestmentQuestions from './pages/client/InvestmentQuestions';
import PersonalityAssessment from './pages/client/PersonalityAssessment';
import AssessmentComplete from './pages/client/AssessmentComplete';

// Auth Pages
import Login from './pages/auth/Login';

// Advisor Pages
import Dashboard from './pages/Dashboard';
import Security from './pages/Security';
import NewAssessment from './pages/advisor/NewAssessment';
import AssessmentDetail from './pages/advisor/AssessmentDetail';
import Clients from './pages/advisor/Clients';
import AdminPanel from './pages/admin/AdminPanel';
import ManageUsers from './pages/admin/ManageUsers';
import ManageStrategies from './pages/admin/ManageStrategies';
import ManagePersonalityQuestions from './pages/admin/ManagePersonalityQuestions';
import ManageHouseView from './pages/admin/ManageHouseView';
import ManageInvestmentGoals from './pages/admin/ManageInvestmentGoals';
import ManageArchetypes from './pages/admin/ManageArchetypes';

function AppRoutes() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<Login />} />

      {/* Public self-service entry (company website link) */}
      <Route path="/apply" element={<PublicStart />} />

      {/* Client Assessment Flow (token-based, no JWT needed) */}
      <Route path="/client-access/:token" element={<ClientAccess />} />
      <Route path="/assessment/:id/welcome" element={<AssessmentWelcome />} />
      <Route path="/assessment/:id/client-info" element={<ClientInfo />} />
      <Route path="/assessment/:id/consent" element={<Consent />} />
      <Route path="/assessment/:id/investment-questions" element={<InvestmentQuestions />} />
      <Route path="/assessment/:id/personality-assessment" element={<PersonalityAssessment />} />
      <Route path="/assessment/:id/complete" element={<AssessmentComplete />} />

      {/* Advisor Routes */}
      <Route path="/dashboard" element={<ProtectedRoute roles={['advisor', 'admin']}><Dashboard /></ProtectedRoute>} />
      <Route path="/assessments/new" element={<ProtectedRoute roles={['advisor', 'admin']}><NewAssessment /></ProtectedRoute>} />
      <Route path="/assessments/:id" element={<ProtectedRoute roles={['advisor', 'admin']}><AssessmentDetail /></ProtectedRoute>} />
      <Route path="/clients" element={<ProtectedRoute roles={['advisor', 'admin']}><Clients /></ProtectedRoute>} />
      <Route path="/security" element={<ProtectedRoute roles={['advisor', 'admin']}><Security /></ProtectedRoute>} />

      {/* Admin Routes */}
      <Route path="/admin" element={<ProtectedRoute roles={['admin']}><AdminPanel /></ProtectedRoute>} />
      <Route path="/admin/users" element={<ProtectedRoute roles={['admin']}><ManageUsers /></ProtectedRoute>} />
      <Route path="/admin/strategies" element={<ProtectedRoute roles={['admin']}><ManageStrategies /></ProtectedRoute>} />
      <Route path="/admin/questions" element={<ProtectedRoute roles={['admin']}><ManagePersonalityQuestions /></ProtectedRoute>} />
      <Route path="/admin/house-view" element={<ProtectedRoute roles={['admin']}><ManageHouseView /></ProtectedRoute>} />
      <Route path="/admin/investment-goals" element={<ProtectedRoute roles={['admin']}><ManageInvestmentGoals /></ProtectedRoute>} />
      <Route path="/admin/archetypes" element={<ProtectedRoute roles={['admin']}><ManageArchetypes /></ProtectedRoute>} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
